<div class="headings">
  <h4 class="content-heading">
    {{ 'pages.userFamily.stepPickFamilyMember.heading' | translate }}
  </h4>
  <h5 class="content-subheading">
    {{ 'pages.userFamily.stepPickFamilyMember.subHeading' | translate }}
  </h5>
</div>

<div *ngFor="let link of familyMemberList">
  <button *ngIf="link.familyApproved && !link.cityApproved" class="bciti-inline-button" (click)="familyMemberClicked(link)">
    <div class="family-member" [ngClass]="selectedFamilyMember == link ? 'family-member-selected' : 'family-member-not-selected'">
      <img class="user-avatar" *ngIf="!link.userId.picture" src="https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png" alt="demo-avatar">
      <img class="user-avatar" *ngIf="link.userId.picture" [src]="link.userId.picture" alt="demo-avatar">
      <div class="row">
        <div class="col">
          <div class="row name">
            <div>{{ link.userId.firstName }} {{ link.userId.lastName }}</div>
          </div>
          <div *ngIf="link?.link" class="row link">
            <div>{{ 'pages.userFamily.linksType.' + (link?.link | lowercase) | translate }}</div>
          </div>
          <div *ngIf="!link.familyApproved" class="row invitation-warning">
            <span class="warning-icon icon-warning"></span>
            {{ 'pages.userFamily.invitationNotAccepted' | translate: { name: link.userId.firstName } }}
          </div>
        </div>
      </div>
    </div>
  </button>
</div>

<div class="mt-s" [ngClass]="highlightWarnings ? 'red-warnings' : 'warnings'">
  <p>{{ 'pages.userFamily.stepPickFamilyMember.warning' | translate }}</p>
</div>